export default "__VITE_ASSET__98a3666e__"